export function page(ctx) {
    return {
        styles: {
            // bg_color: was ctx.SCR (COLOR_SCR, the generic "pretty" object background,
            // #545b6a) — but a HASP screen/page is themed via LV_THEME_SCR
            // (lv_obj_create(NULL, NULL), LVGL lv_obj.c), which resolves to firmware's
            // styles->screen, whose bg_color is the DIFFERENT constant COLOR_SCR_BG
            // (lv_theme_hasp.c:29-30,287): black in the dark theme, not COLOR_SCR. The two
            // constants only happen to coincide in the light theme (both white), which is why
            // this bug was invisible there. border_width:0 already matches firmware's real
            // styles->screen (border_opa is also 0 — fully invisible — so border_color has no
            // visible effect either way).
            main: { bg_color: ctx.SCR_BG, bg_opa: 255, border_width: 0, border_color: ctx.BORDER },
        },
    };
}
